// extracted by mini-css-extract-plugin
export default {"buttonBlock":"AddSectionSwiper_buttonBlock__1jQrM","left":"AddSectionSwiper_left__AmzG7","right":"AddSectionSwiper_right__bsI0N"};